export default __webpack_public_path__ + "static/media/user3.a57a5165.jpg";